(() => {
  const formatMoney = (cents, currency) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(cents || 0) / 100)

  const initialize = root => {
    if (!root || root.dataset.uvpInitialized === 'true') return
    root.dataset.uvpInitialized = 'true'

    const variantsNode = root.querySelector('[data-uvp-variants]')
    const variantSelect = root.querySelector('[data-uvp-variant-select]')
    const priceNode = root.querySelector('[data-uvp-price]')
    const priceNote = root.querySelector('[data-uvp-price-note]')
    const addButton = root.querySelector('[data-uvp-add]')
    const addLabel = root.querySelector('[data-uvp-add-label]')
    const quantityInput = root.querySelector('[data-uvp-quantity-input]')
    const currency = root.dataset.currency || 'USD'
    let variants = []

    try {
      variants = JSON.parse(variantsNode?.textContent || '[]')
    } catch (error) {
      variants = []
    }

    const optionGroups = Array.from(root.querySelectorAll('[data-uvp-option]'))
    const currentOptions = () => optionGroups.map(group => group.querySelector('input:checked')?.value || '')

    const updateFinishAvailability = size => {
      const finishGroup = optionGroups[1]
      if (!finishGroup) return
      finishGroup.querySelectorAll('input[type="radio"]').forEach(input => {
        input.disabled = !variants.some(variant => variant.available && variant.options?.[0] === size && variant.options?.[1] === input.value)
      })
    }

    const resolveVariant = changedIndex => {
      let options = currentOptions()
      if (changedIndex === 0) {
        updateFinishAvailability(options[0])
        let exact = variants.find(variant => variant.available && variant.options?.every((value, index) => value === options[index]))
        if (!exact) {
          exact = variants.find(variant => variant.available && variant.options?.[0] === options[0])
          const fallbackFinish = optionGroups[1]?.querySelector(`input[value="${CSS.escape(exact?.options?.[1] || '')}"]`)
          if (fallbackFinish) fallbackFinish.checked = true
          options = currentOptions()
        }
      }
      return variants.find(variant => variant.available && variant.options?.every((value, index) => value === options[index])) || null
    }

    const updateVariant = changedIndex => {
      const variant = resolveVariant(changedIndex)
      if (!variant) {
        if (addButton) addButton.disabled = true
        if (addLabel) addLabel.textContent = 'Unavailable'
        return
      }

      if (variantSelect) {
        variantSelect.value = String(variant.id)
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }))
      }
      if (priceNode) priceNode.textContent = formatMoney(variant.price, currency)
      if (addButton) addButton.disabled = !variant.available
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out'
      if (history.replaceState) {
        const url = new URL(window.location.href)
        url.searchParams.set('variant', variant.id)
        history.replaceState({}, '', url)
      }
    }

    optionGroups.forEach((group, index) => {
      group.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"]')) updateVariant(index)
      })
    })

    const updateQuantityState = () => {
      if (!quantityInput) return
      const quantity = Math.max(1, Math.floor(Number(quantityInput.value) || 1))
      quantityInput.value = String(quantity)
      let activeTier = 0
      root.querySelectorAll('[data-uvp-tier]').forEach(tier => {
        const threshold = Number(tier.dataset.uvpTier)
        if (quantity >= threshold && threshold > activeTier) activeTier = threshold
      })
      root.querySelectorAll('[data-uvp-tier]').forEach(tier => {
        tier.classList.toggle('is-active', Number(tier.dataset.uvpTier) === activeTier)
      })
      if (priceNote) priceNote.textContent = activeTier ? 'each before cart discount' : 'per transfer'
    }

    root.querySelectorAll('[data-uvp-quantity]').forEach(button => {
      button.addEventListener('click', () => {
        if (!quantityInput) return
        const direction = button.dataset.uvpQuantity === 'plus' ? 1 : -1
        quantityInput.value = String(Math.max(1, (Number(quantityInput.value) || 1) + direction))
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }))
      })
    })
    quantityInput?.addEventListener('input', updateQuantityState)
    quantityInput?.addEventListener('change', updateQuantityState)

    const showSlide = index => {
      root.querySelectorAll('[data-uvp-slide]').forEach(slide => {
        const active = Number(slide.dataset.uvpSlide) === index
        slide.hidden = !active
        slide.classList.toggle('is-active', active)
      })
      root.querySelectorAll('[data-uvp-thumb]').forEach(thumb => {
        const active = Number(thumb.dataset.uvpThumb) === index
        thumb.classList.toggle('is-active', active)
        thumb.setAttribute('aria-pressed', String(active))
      })
    }

    root.querySelectorAll('[data-uvp-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.uvpThumb)))
    })

    const dialogOpeners = new WeakMap()
    root.querySelectorAll('[data-uvp-dialog-open]').forEach(button => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.uvpDialogOpen)
        if (dialog) dialogOpeners.set(dialog, button)
        dialog?.showModal()
      })
    })

    root.querySelectorAll('[data-uvp-dialog]').forEach(dialog => {
      dialog.querySelector('[data-uvp-dialog-close]')?.addEventListener('click', () => dialog.close())
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close()
      })
      dialog.addEventListener('close', () => dialogOpeners.get(dialog)?.focus())
    })

    updateFinishAvailability(currentOptions()[0])
    updateQuantityState()
  }

  const initializeAll = scope => scope.querySelectorAll('[data-uvp-v2]').forEach(initialize)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(document))
  } else {
    initializeAll(document)
  }

  document.addEventListener('shopify:section:load', event => initializeAll(event.target))
})()
